/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const AddToListIcon = createIcon(
  '0 0 20 20',
  <path d="M2 2h16v2H2zm0 6h10v2H2zm6 6H2v2h6zm6 0v-4h2v4h4v2h-4v4h-2v-4h-4v-2z" />,
);
